import React from 'react'
import { useScript } from './useScript'

export const PipedriveForm = () => {
  useScript('https://webforms.pipedrive.com/f/loader', () => {
    // make sure it is loaded only once per spa
  })
  return (
    <div
      className="pipedriveWebForms"
      data-pd-webforms="https://webforms.pipedrive.com/f/bXB6ZC6klHc7Nm2xZ3Fhk9X50ypgycU2ezViSqCv2jObisGa5OCdw52uq8oZXak1zl"
    />
  )
}
